import React from 'react'

const LearnDevelop = () => {
  return (
    <div>
      <h1>Learning & Development</h1>
    </div>
  )
}

export default LearnDevelop
